import React, { useState } from 'react';
import MySeminars from "./MySeminars";
import MyContests from "./MyContests";
import MyTrainingCourses from "./MyTrainingCourses";
import MyConferences from "./MyConferences";
import { useTranslation } from "../../context/TranslationContext"; 
import SectionTabs from "../../component/SectionTabs"; 

export default function MyActivity() {
  const [selectedSection, setSelectedSection] = useState("myContests");

  const { translations, language } = useTranslation(); 
  const isArabic = language === "ar";

  const handleSelectChange = (event) => {
    setSelectedSection(event.target.value);
  };

  const sections = {
    myContests: {
      label: translations.contestsButton,
    },
    myTrainingCourses: {
      label: translations.trainingCoursesButton,
    },
    myConferences: {
      label: translations.conferencesButton,
    },
    mySeminars: {
      label: translations.seminarsButton,
    },
  };

  const buttonBaseClasses = "flex items-center mx-1 px-4 py-2 rounded-lg text-l font-bold text-black focus:outline-none";
  const isActive = (sectionKey) => selectedSection === sectionKey ? "bg-primary-blue text-white" : "bg-blue hover:bg-primary-blue hover:text-white";

  return (
    <div className={`flex ${isArabic ? 'flex-col md:flex-row' : 'flex-col-reverse md:flex-row-reverse '} pt-24 w-full`}>
      <div
        className="flex-1"
        style={{
          fontFamily: "Tajwal, sans-serif",
          direction: isArabic ? "rtl" : "ltr",
          textAlign: isArabic ? "right" : "left",
        }}
      >
        <h2 className="text-xl font-bold mb-1">{translations.titleActivity}</h2>
        <h4 className="text-l font-bold text-gray-500 mb-4">{translations.descriptionActivity}</h4>

        <SectionTabs
          sections={sections}
          selectedSection={selectedSection}
          onChange={handleSelectChange}
        />

        {/* الأزرار للسكرين الأكبر */}
        <div className="hidden sm:flex flex-wrap justify-center md:justify-start mt-4 gap-2">
          <button
            className={`${buttonBaseClasses} ${isActive("myContests")}`}
            onClick={() => setSelectedSection("myContests")}
          >
            {translations.contestsButton}
          </button>
          <button
            className={`${buttonBaseClasses} ${isActive("myTrainingCourses")}`}
            onClick={() => setSelectedSection("myTrainingCourses")}
          >
            {translations.trainingCoursesButton}
          </button>
          <button
            className={`${buttonBaseClasses} ${isActive("myConferences")}`}
            onClick={() => setSelectedSection("myConferences")}
          >
            {translations.conferencesButton}
          </button>
          <button
            className={`${buttonBaseClasses} ${isActive("mySeminars")}`}
            onClick={() => setSelectedSection("mySeminars")}
          >
            {translations.seminarsButton}
          </button>
        </div>

        <div className="mt-4">
          {selectedSection === "myContests" && <MyContests />}
          {selectedSection === "myTrainingCourses" && <MyTrainingCourses />}
          {selectedSection === "myConferences" && <MyConferences />}
          {selectedSection === "mySeminars" && <MySeminars />}
        </div>
      </div>
    </div>
  );
}
